/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react'
import { Col, Card, CardBody, ModalBody, Modal, ModalHeader, ModalFooter, Button, Row, Label, Input, Form, Badge, UncontrolledTooltip, UncontrolledButtonDropdown, DropdownMenu, DropdownItem, DropdownToggle, FormFeedback } from 'reactstrap'
import Avatar from '@components/avatar'
import { PlusSquare, Download, Trash } from 'react-feather'
import Select from 'react-select'
import { BarcodeGeneratorComponent, QRCodeGeneratorComponent, DataMatrixGeneratorComponent } from '@syncfusion/ej2-react-barcode-generator'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import toast from 'react-hot-toast'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { configGetDizionariCombo, configSetProdottoCodici, configDeleteProdottoCodici } from '../../../../@core/auth/apiService/configs'

const DetailsCode = (props) => {
    const { newData } = props
    // STATE
    const [data, setData] = useState([])
    const [centeredModal, setCenteredModal] = useState(false)
    const [type, setType] = useState()
    const [typeId, setTypeId] = useState()
    const [value, setValue] = useState('')
    const [fornitoreId, setFornitoreId] = useState(1)

    useEffect(() => { setData(newData) }, [])

    const typeChange = (tipo, tipoId) => {
        setType(tipo)
        setTypeId(tipoId)
    }
    const valueChange = (valore) => {
        setValue(valore)
    }
    const fornitoreChange = (fornitoreId) => {
        setFornitoreId(fornitoreId)
    }
    const fornitore = [{ label: 'Default', value: '1' }]

    const defaultSchema = yup.object().shape({
        codice: yup.string().required(),
    })

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({ mode: 'onChange', resolver: yupResolver(defaultSchema), defaultValues: value })

    const onError = (errors, e) => {
        toast.error('Codice non registrato, controlla i campi richiesti', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })
    }
    const onSubmit = () => {
        chiamataCodice()
        setCenteredModal(!centeredModal)
    }

    // CODE LO PASSO ALLA CHIAMATA PER REGISTRARE IL CODICE NEL DB 
    const code = {
        id: 0,
        prodotto: { id: props.value },
        fornitore: { id: 1 },
        tipoCodice: { id: typeId },
        codice: value
    }
    const codePush = {
        id: 0,
        codice: value,
        fornitore: [{ id: 1 }],
        tipoCodice: [{ id: typeId, codice: type }]
    }

    //CHIAMATE !!!!!!!!!


    //CALL SET-CODICEPRODOTTO
    const chiamataCodice = async () => {
        const myResponse = await axios(configSetProdottoCodici(JSON.stringify([{ ...code }])))
        if (myResponse.data.esito === 'OK') {
            codePush.id = myResponse.data.codiceProdotto.id
            toast.success('Codice aggiunto con successo', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
            data.push(codePush)
            setData([...data])
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }

    }
    //CALL DELETE CODICE PRODOTTO
    const deleteCodice = async (id, i) => {
        const myResponse = await axios(configDeleteProdottoCodici(JSON.stringify([{ id }])))
        if (myResponse.data.esito === 'OK') {
            toast.success('Codice rimosso con successo', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
            data.splice(i, 1)
            setData([...data])
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }

    }
    let barcodeInstance;
    //SESSIONE CODICE INTERNA AL MODAL 
    const CodeGeneratorModal = () => {
        if (type === 'QRCode') { return (<QRCodeGeneratorComponent width={"200px"} height={"150px"} value={value}></QRCodeGeneratorComponent>) }
        else if (type === 'DataMatrix') { return (<DataMatrixGeneratorComponent width={"200px"} height={"150px"} value='Syncfusion'></DataMatrixGeneratorComponent>) }
        else {
            return <BarcodeGeneratorComponent invalid={(args) => {
            }} width={"200px"} height={"150px"} mode='SVG' type={type} value={value}></BarcodeGeneratorComponent>
        }
    }
    // SESSIONE CODICI PRE-REGISTRATI
    const CodeGeneratorRender = (e) => {
        if (e.tipoCodice[0].codice === 'QRCode') { return (<QRCodeGeneratorComponent ref={barcode => (barcodeInstance = barcode)} mode='PNG' width={"180px"} height={"125px"} value={e.codice}></QRCodeGeneratorComponent>) }
        else if (e.tipoCodice[0].codice === 'DataMatrix') { return (<DataMatrixGeneratorComponent ref={barcode => (barcodeInstance = barcode)} width={"180px"} height={"125px"} value={e.codice}></DataMatrixGeneratorComponent>) }
        else {
            return <BarcodeGeneratorComponent invalid={() => {
            }} ref={barcode => (barcodeInstance = barcode)} width={"180px"} height={"125px"} mode='SVG' type={e.tipoCodice[0].codice} value={e.codice}></BarcodeGeneratorComponent>
        }
    }

    const CodiciDaMostrare = () => {
        if (data) {
            return (
                data.map((e, i) => {
                    return (
                        <Col key={i} className='mb-1' xl='4' md='6' sm='12'>
                            <CardBody>
                                <div className=' d-flex flex-column justify-content-center align-items-center  rounded' style={{ height: '328px', border: '1px solid grey' }}>
                                    <Badge color='light-primary' pill id={'badge' + `${i}`}>
                                        {e.tipoCodice.length > 0 ? e.tipoCodice[0].codice.toUpperCase() + '-' + e.codice.substring(0, 20) : ''}
                                    </Badge>
                                    <UncontrolledTooltip placement='top' target={'badge' + `${i}`}>
                                        {e.tipoCodice.length > 0 ? e.tipoCodice[0].codice.toUpperCase() + '-' + e.codice : ''}
                                    </UncontrolledTooltip>
                                    <CodeGeneratorRender {...e}></CodeGeneratorRender>
                                    <Row>
                                        <div style={{ marginTop: '20px' }}>
                                            <UncontrolledButtonDropdown className='btn-icon' style={{ marginRight: '40px' }}>
                                                <DropdownToggle color='secondary' caret>
                                                    <Download size={16} />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem onClick={() => barcodeInstance.exportImage(e.tipoCodice[0].codice.toUpperCase() + '-' + e.codice, 'JPG')} tag='a'>JPG</DropdownItem>
                                                    <DropdownItem onClick={() => barcodeInstance.exportImage(e.tipoCodice[0].codice.toUpperCase() + '-' + e.codice, 'PNG')} tag='a'>PNG</DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                            <Button className='btn-icon' onClick={() => deleteCodice(e.id, i)}>
                                                <Trash size={16} />
                                            </Button>
                                        </div>
                                    </Row>
                                </div>
                            </CardBody>
                        </Col>
                    )
                }))

        }
    }
    //SCHERMATA PRINCIPALE
    return (
        <Card>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit, onError)}>
                    <Row>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <CardBody>
                                <div className=' d-flex flex-column justify-content-center align-items-center bg-light-primary rounded' style={{ height: '328px' }}>
                                    <Avatar size='xl' color='primary' onClick={() => setCenteredModal(!centeredModal)} icon={<PlusSquare> </PlusSquare>} />
                                    <Label> Aggiungi codice </Label>
                                    <Modal isOpen={centeredModal} backdrop='static' toggle={() => setCenteredModal(!centeredModal)} className='modal-dialog-centered modal-lg'>
                                        <ModalHeader toggle={() => setCenteredModal(!centeredModal)}>Genera Codice</ModalHeader>
                                        <ModalBody>
                                            <Row>
                                                <Col className='mb-1' xl='6' md='6' sm='12'>
                                                    <Label className='form-label' for='tipoCodice'>
                                                        Tipo Codice
                                                    </Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={async () => {
                                                            const myResponse = await axios(configGetDizionariCombo({}))
                                                            const prodotti = myResponse.data.tipoCodice.map(item => ({
                                                                label: item.descrizione,
                                                                value: item.codice,
                                                                id: item.id
                                                            }))
                                                            return prodotti;
                                                        }}
                                                        onChange={e => typeChange(e.value, e.id)}
                                                        name='unita'
                                                        className='react-select'
                                                        classNamePrefix='select'
                                                    />
                                                    <Label className='form-label' for='codice'>
                                                        Codice
                                                    </Label>
                                                    <Controller
                                                        id='codice'
                                                        name='codice'
                                                        defaultValue={''}
                                                        control={control}
                                                        render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                                            onChange(value);
                                                            valueChange(value)
                                                        }}
                                                            value={value || ''}

                                                            invalid={errors.codice && true} />}
                                                    />
                                                    {errors.codice && <FormFeedback>{errors.codice.message}</FormFeedback>}
                                                    <Label className='form-label' for='fornitore'>
                                                        Fornitore
                                                    </Label>
                                                    <Select
                                                        className='react-select'
                                                        classNamePrefix='select'
                                                        options={fornitore}
                                                        onChange={e => { fornitoreChange(e.value) }}
                                                    />
                                                </Col>
                                                <Col className='mb-1 d-flex flex-column justify-content-center align-items-center' xl='6' md='6' sm='12' >
                                                    <div className={type !== 'Ean8' ? 'd-none' : 'd-block'}>
                                                        <p> L'EAN-8 deve avere almeno 8 numeri</p>
                                                        <p>Esempio : 11223344 </p>
                                                    </div>
                                                    {type ? <CodeGeneratorModal /> : <p>Seleziona un Tipo Codice</p>}
                                                </Col>
                                            </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button type='Submit' disabled={!code.tipoCodice.id} onClick={handleSubmit(onSubmit, onError)} color='primary'>Salva</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </CardBody>
                        </Col>
                        <CodiciDaMostrare></CodiciDaMostrare>
                    </Row>
                </Form>
            </CardBody>
        </Card>
    )
}

export default DetailsCode